import React, { useEffect, useState } from "react";

const SectionBanner = () => {
    const [banners, setBanners] = useState([]);
    const [subCategoryMap, setSubCategoryMap] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [bannersRes, headerRes] = await Promise.all([
                    fetch("https://api.welbeing.in/home/banners/"),
                    fetch("https://api.welbeing.in/header/"),
                ]);

                const bannersData = await bannersRes.json();
                const headerData = await headerRes.json();

                if (bannersData.status === "success") {
                    setBanners(bannersData.data);
                } else {
                    throw new Error("Failed to fetch banners");
                }

                if (headerData.status === "success") {
                    const map = {};
                    (headerData.data || []).forEach((group) => {
                        (group.subcategories || []).forEach((sub) => {
                            map[String(sub.sub_id)] = sub.sub_cate;
                        });
                    });
                    setSubCategoryMap(map);
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading) {
        return (
            <section className="ratio_asos mt-3">
                <div className="container-lg">
                    <div className="text-center py-4">
                        <span className="spinner-border" style={{ color: "#911077" }} role="status"></span>
                    </div>
                </div>
            </section>
        );
    }

    if (error || banners.length === 0) return null;

    const displayBanners = banners.slice(0, 6);

    return (
        <section className="ratio_asos py-3">
            <div className="container-lg">
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(3, 1fr)",
                        gap: "12px",
                    }}
                >
                    {displayBanners?.map((banner) => {
                        const subCategoryName =
                            subCategoryMap[String(banner.sub_id)] || banner.sub_cate || "";
                        const Wrapper = banner.sub_id ? "a" : "div";
                        const wrapperProps = banner.sub_id
                            ? {
                                  href: `/products?id=${banner.sub_id}`,
                                  style: { textDecoration: "none", color: "inherit", display: "block" },
                              }
                            : { style: { display: "none" } };

                        return (
                            <Wrapper key={banner.id} {...wrapperProps}>
                                <div
                                    style={{
                                        position: "relative",
                                        width: "100%",
                                        borderRadius: "12px",
                                        overflow: "hidden",
                                    }}
                                >
                                    <img
                                        src={`https://api.welbeing.in/uploads/section-banners/${banner.image}`}
                                        alt={subCategoryName || "Banner"}
                                        style={{
                                            width: "100%",
                                            height: "200px",
                                            objectFit: "cover",
                                            display: "block",
                                        }}
                                        onError={(e) => (e.target.src = "customer_data/no_image.webp")}
                                    />

                                    <div
                                        style={{
                                            position: "absolute",
                                            inset: 0,
                                            background:
                                                "linear-gradient(to right, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.1) 60%, transparent 100%)",
                                        }}
                                    />
                                </div>

                                {subCategoryName && (
                                    <div
                                        style={{
                                            padding: "10px 5px",
                                            textAlign: "center",
                                            fontWeight: 600,
                                        }}
                                    >
                                        {subCategoryName}
                                    </div>
                                )}
                            </Wrapper>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default SectionBanner;
